export const defaultStateTypes = {
  enable: {
    key: "enable",
    value: "enable",
    label: "Enable"
  },
  disable: {
    key: "disable",
    value: "disable",
    label: "Disable",
  }
}

export const defaultPortTypes = {
  "access": { label: "Access", value: "access", key: "access" },
  "trunk": { label: "Trunk", value: "trunk", key: "trunk" },
}

export const defaultProfile = {
  id: "",
  name: "No Profile",
  value: "No Profile",
  label: "No Profile",
  portProfile: "",
  deviceCategory: null,
  assignedPort: [],
  portTags: [],
  allowVlan: null,
  PVID: null,
  portType: null,
  portState: true,
  poeState: true,
  ddpState: true,
  lbdState: true,
  speed: "auto",
  comboSfpSpeed: "auto",
  version: null,
  isDefault: true,
}

export const defaultLinkSpeedOptionsDefinitions = {
  "a": { id: 0, label: "Auto", value: "auto", isSelected: false },
  "100": { id: 1, label: "100 Gbps Full Duplex", value: "100G_full", isSelected: false },
  "40": { id: 2, label: "40 Gbps Full Duplex", value: "40G_full", isSelected: false },
  "25": { id: 3, label: "25 Gbps Full Duplex", value: "25G_full", isSelected: false },
  "10": { id: 4, label: "10 Gbps Full Duplex", value: "10G_full", isSelected: false },
  "5": { id: 5, label: "5 Gbps Full Duplex", value: "5G_full", isSelected: false },
  "2.5": { id: 6, label: "2.5 Gbps Full Duplex", value: "2.5G_full", isSelected: false },
  "1": { id: 7, label: "1 Gbps Full Duplex", value: "1G_full", isSelected: false },
  "10m": { id: 8, label: "10 Mbps Full Duplex", value: "10M_full", isSelected: false },
  "100m": { id: 9, label: "100 Mbps Full Duplex", value: "100M_full", isSelected: false },
};